(function () {
  var root = document.querySelector('[data-la-pdp]');
  if (!root) return;

  var crumbs = root.querySelector('[data-la-pdp-crumbs]');
  if (crumbs && crumbs.dataset.laPdpCrumbContext !== 'collection' && crumbs.dataset.laPdpCrumbContext !== 'search') {
    var arrivedFromSearch = false;
    try {
      arrivedFromSearch = new URLSearchParams(window.location.search).get('via') === 'search';
    } catch (e) {
      arrivedFromSearch = false;
    }
    if (!arrivedFromSearch) {
      try {
        var referrer = new URL(document.referrer);
        arrivedFromSearch =
          referrer.origin === window.location.origin && /^\/search(\/|$)/.test(referrer.pathname);
      } catch (e) {
        arrivedFromSearch = false;
      }
    }
    if (arrivedFromSearch) {
      var collectionCrumb = crumbs.querySelector('[data-la-pdp-crumb-collection]');
      var searchCrumb = crumbs.querySelector('[data-la-pdp-crumb-search]');
      if (searchCrumb) {
        if (collectionCrumb) collectionCrumb.hidden = true;
        searchCrumb.hidden = false;
      }
    }
  }

  var atc = root.querySelector('[data-la-pdp-atc]');
  var sticky = root.querySelector('[data-la-pdp-sticky]');
  var stickyBtn = sticky && sticky.querySelector('[data-la-pdp-sticky-submit]');
  var submit = root.querySelector('[type="submit"][name="add"]');

  if (atc && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        root.classList.toggle('la-pdp--sticky-open', show);
      },
      { threshold: 0 }
    ).observe(atc);
  }

  var stickyMeta = sticky && sticky.querySelector('[data-la-pdp-sticky-meta]');

  if (stickyBtn && submit) {
    stickyBtn.addEventListener('click', function () {
      submit.click();
    });

    var syncSticky = function (event) {
      var label = submit.querySelector('span');
      if (label) stickyBtn.textContent = label.textContent.trim();
      stickyBtn.disabled = submit.hasAttribute('disabled');

      var variant = event && event.data && event.data.variant;
      if (stickyMeta && variant && variant.title) {
        stickyMeta.textContent = variant.title;
      }
    };

    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.variantChange, syncSticky);
    }
  }

  root.querySelectorAll('[data-la-pdp-feel]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('[data-la-pdp-feel]').forEach(function (other) {
        other.setAttribute('aria-pressed', 'false');
      });
      btn.setAttribute('aria-pressed', 'true');
    });
  });

  var sizeGuideOpener = root.querySelector('[data-la-pdp-size-guide-opener]');
  if (sizeGuideOpener) {
    var sizeSelect = root.querySelector('select[name="options[Size]"]');
    var sizeField = sizeSelect && sizeSelect.closest('.product-form__input');
    var sizeSelectWrapper = sizeField && sizeField.querySelector('.select');
    if (sizeField && sizeSelectWrapper) {
      sizeField.classList.add('la-pdp__size-field--has-guide');
      sizeField.insertBefore(sizeGuideOpener, sizeSelectWrapper);
    }
  }

  root.querySelectorAll('[data-la-pdp-description]').forEach(function (box) {
    var moreBtn = box.querySelector('[data-la-pdp-read-more]');
    var lessBtn = box.querySelector('[data-la-pdp-read-less]');
    var teaser = box.querySelector('[data-la-pdp-description-teaser]');
    var full = box.querySelector('[data-la-pdp-description-full]');
    if (!moreBtn || !lessBtn || !teaser || !full) return;

    var setExpanded = function (expanded) {
      box.classList.toggle('is-expanded', expanded);
      moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      teaser.hidden = expanded;
      full.hidden = !expanded;
    };

    moreBtn.addEventListener('click', function () {
      setExpanded(true);
    });
    lessBtn.addEventListener('click', function () {
      setExpanded(false);
    });
  });

  var mono = root.querySelector('[data-la-pdp-mono]');
  var extra = root.querySelector('[data-la-pdp-mono-extra]');
  if (mono && extra) {
    var sync = function () {
      extra.hidden = !mono.checked;
      extra.querySelectorAll('input, select').forEach(function (el) {
        el.disabled = !mono.checked;
      });
    };
    mono.addEventListener('change', sync);
    sync();
  }
})();
